// extracted by mini-css-extract-plugin
export var base = "_1e-0";
export var updateBanner = "_1e-1";